const stateSelector = state => state.waitingList

export const waitlistIdSelector = createSelector(stateSelector, waitingList => waitingList.waitingListId)
export const waitlistIdProductSelector = createSelector(
    stateSelector,
    waitingList => waitingList.waitingListState?.productCd
)
export const waitlistStateSelector = createSelector(stateSelector, waitingList => waitingList.waitingListState?.state)
export const waitlistErrorSelector = createSelector(stateSelector, waitingList => waitingList.waitingListStateError)
